import { ConfigProvider as OriginalConfigProvider } from '@alifd/next';
import moment from 'moment';
import 'moment/locale/zh-cn';
import zhCN from '@alifd/next/lib/locale/zh-cn';
import enUS from '@alifd/next/lib/locale/en-us';

const BefConfigProvider = (props: any) => {
  const { locale, ...rest } = props;

  let localeData = locale;
  if (typeof locale === 'string') {
    if (locale.toLowerCase() === 'zh-cn') {
      moment.locale('zh-cn');
      localeData = zhCN;
    } else if (locale.toLowerCase() === 'en-us') {
      moment.locale('en');
      // 默认为英文
      localeData = enUS;
    }
  }

  return <OriginalConfigProvider locale={localeData} {...rest} />;
};

export default BefConfigProvider;
